/**
 * KAN-752: инструкции оператора: части из реестра с превью (KAN-751) и
 * материалы для клиента (KAN-702/721). Общая разметка для вкладки
 * "Инструкции" страницы оператора.
 */
import { OperatorSectionsEditor } from './OperatorSectionsEditor';
import { InstructionAttachments } from './InstructionAttachments';
import type { UserEditForm } from '@/hooks/useUserEditForm';
import type { User } from '@/types/user';

interface OperatorInstructionsFieldsProps {
  user: User;
  form: UserEditForm;
}

export function OperatorInstructionsFields({ user, form }: OperatorInstructionsFieldsProps): JSX.Element {
  return (
    <>
      <OperatorSectionsEditor
        userId={user.id}
        value={form.promptSections}
        onChange={form.setPromptSections}
        legacyPrompt={user.user_prompt || ''}
        errors={form.sectionErrors}
      />
      <InstructionAttachments operatorId={user.id} />
    </>
  );
}

export default OperatorInstructionsFields;
